import { useFetch } from "matsuri-hooks"
import { Prefecture } from "@/domain/prefecture"
import { listPrefectures } from "@/endpoints/m2m-core.v1"

export const usePrefectures = () => {
    return useFetch<Prefecture[]>(listPrefectures(), {})
}
